<template>
  <slot name="header" />
  <DietDetailWeekSchedule :schedule="view.schedule" :start-day-index="view.startDayIndex" />
  <DietDetailWeekNutrients
    :average-active="averageActive"
    :basic-nutrients="view.basicNutrients"
    :chosen-nutrients="view.chosenNutrients"
    :specific-nutrients="view.specificNutrients"
    :visible-days-count="visibleDaysCount"
  />
</template>

<script setup lang="ts">
  import DietDetailWeekNutrients from '@/components/diets/DietDetailWeekNutrients.vue'
  import DietDetailWeekSchedule from '@/components/diets/DietDetailWeekSchedule.vue'

  import type { DietWeekViewModel } from '../../types'

  defineProps<{ averageActive: boolean; view: DietWeekViewModel; visibleDaysCount: number }>()
</script>
